import React from 'react';
import { ContainerLoading } from './Loading elements';

import LoadingIcon from '../icons/LoadingIcon';

const Loading = () => {
    return (
        <ContainerLoading>
            <LoadingIcon />
        </ContainerLoading>
    );
};

export default Loading;